export default {
  PLANTIO: 0,
  TALHAO: 1
};
